import { useEffect, useCallback } from 'react';
import { useGameStore, selectCanCashOut } from '@stores/gameStore';
import { useRGS } from './useRGS';

/**
 * Keyboard shortcuts for game controls
 * - SPACE: Cash out during playing phase
 */
export function useKeyboardShortcuts(): void {
  const canCashOut = useGameStore(selectCanCashOut);
  const { cashOut } = useRGS();

  const handleKeyDown = useCallback(
    (event: KeyboardEvent) => {
      // Ignore if user is typing in an input
      if (
        event.target instanceof HTMLInputElement ||
        event.target instanceof HTMLTextAreaElement
      ) {
        return;
      }

      switch (event.code) {
        case 'Space':
          event.preventDefault();
          if (canCashOut) {
            cashOut();
          }
          break;
        default:
          break;
      }
    },
    [canCashOut, cashOut]
  );

  useEffect(() => {
    window.addEventListener('keydown', handleKeyDown);
    return (): void => {
      window.removeEventListener('keydown', handleKeyDown);
    };
  }, [handleKeyDown]);
}
